/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterP = createReactComponent("letter-p", "IconLetterP", [
  ["path", { d: "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5", key: "svg-0" }]
]);

export { IconLetterP as default };
//# sourceMappingURL=IconLetterP.js.map
